/* Start VA Custom code */
jQuery(document).ready(function ($) {
  $('.pills-variant-labels img').click(function (e) {
    var title = $(this).attr('title');
    $('.pgvn').html('<span>' + title + '</span>').show();
  });

  $('.swiper-btn').click(function (e) {
    $('.pgvn').html('').hide();
  });

  $('.swiper-pagination__wrapper').click(function (e) {
    $('.pgvn').html('').hide();
  });

  $('.body-template-cart h1.main-page-title').text('My Samples');
  $('.body-template-cart .breadcrumb span').text('My Samples');

  $('#create_customer .button').click(function (e) {
    var companyName = $('#RegisterForm-Company-Name').val();
    var companyFirstName = $('#RegisterForm-FirstName').val();
    var companytitle = $('#RegisterForm-title').val();
    var companyEmail = $('#RegisterForm-email').val();
    var companyType = $('#RegisterForm-Company-Type').val();
    var companyPass = $('#RegisterForm-password').val();
    if (
      companyName == '' ||
      companyFirstName == '' ||
      companytitle == '' ||
      companyEmail == '' ||
      companyType == '' ||
      companyPass == ''
    ) {
      $('.error-message').text('Please complete all fields with * above to continue!');
      return false;
    }
  });

  jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 80) {
      jQuery('body').addClass('sticky');
    } else {
      jQuery('body').removeClass('sticky');
    }
  });
});
/* End VA Custom code */